<template>
    <section class="mx-4 my-8 bg-gray-light p-2 md:p-12">
        <best-available-offer></best-available-offer>
        <p class="mb-4 text-sm text-center italic">All prices are in USD.</p>
        <div
            class="xl:w-4/5 xl:mx-auto md:flex md:justify-around md:space-x-2 space-y-2 md:space-y-0"
        >
            <free-plan
                v-if="isEligibleForFreePlan"
                :current="current.plan"
                :features="available.free.features"
                @picked="pick('Free', 'free')"
            ></free-plan>

            <paid-plan
                :current="current.plan"
                name="Mailman"
                id="v2-premium"
                :monthly-price="10"
                :yearly-price="96"
                :monthly-additional-price="5"
                :yearly-additional-price="36"
                :features="available.premium.features"
                @picked="pick('Premium', $event)"
            ></paid-plan>
        </div>
    </section>
</template>

<script>
import ChangePlanModal from "./ChangePlanModal";
import SubscribeModal from "./SubscribeModal";
import UnsubscribeModal from "./UnsubscribeModal";

export default {
    props: {
        plan: {
            type: String,
            required: false,
        },
        endpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            current: {
                plan: this.plan || null,
            },
            available: {
                free: {
                    features: [
                        { type: "included", value: "Email batching" },
                        { type: "included", value: "Activity Logs" },
                        {
                            type: "included",
                            value: "Limited delivery scheduling",
                        },
                        { type: "excluded", value: "Limited VIPs" },
                        {
                            type: "excluded",
                            value: "No weekly delivery scheduling",
                        },
                    ],
                },
                premium: {
                    features: [
                        { type: "included", value: "Snooze your inbox" },
                        { type: "included", value: "Multiple inbox support" },
                        { type: "included", value: "Activity logs" },
                        {
                            type: "included",
                            value: "Custom delivery scheduling",
                        },
                        {
                            type: "included",
                            value: "Custom Do-Not-Disturb period",
                        },
                        { type: "included", value: "VIP lists" },
                        { type: "included", value: "Unlimited reviewing" },
                        { type: "bonus", value: "20% Savings" },
                        { type: "bonus", value: "One invoice, instead of 12" },
                    ],
                },
            },
            isEligibleForFreePlan: User.is_eligible_for_free_plan,
        };
    },
    methods: {
        is(plan) {
            return plan === this.current.plan;
        },
        pick(name, plan) {
            const intent = this.identifyIntent(plan);

            Modal.show(intent, {
                propsData: {
                    plan: plan,
                    name: name,
                    endpoint: this.endpoint,
                },
            })
                .then((response) => {
                    window.location.reload();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        identifyIntent(plan) {
            if (this.current.plan === null && plan === "free") {
                // staying on the free plan, so, do nothing
                return null;
            }

            if (this.current.plan === null && plan !== "free") {
                // upgrading from free to a paid plan, so, show subscribe modal
                return SubscribeModal;
            }

            if (this.current.plan !== null && plan === "free") {
                // downgrading from paid plan to free plan, so, show cancel modal
                return UnsubscribeModal;
            }

            if (this.current.plan !== null && plan !== "free") {
                // switching between paid plans, so, show change plan modal
                return ChangePlanModal;
            }
        },
    },
};
</script>
